import { defineStore } from 'pinia'
import { usePartnerConfigStore } from '@/stores/partnerConfig'

export type HealthStatus = 'up_to_date' | 'downloaded' | 'out_of_date' | null

export interface OfflineState {
  status: HealthStatus
  timestamp: string | null
  readyForOffline: boolean
}

export interface SendResult {
  status: HealthStatus
  timestamp: string
}

export const useOfflineStore = defineStore('offline', {
  state: (): OfflineState => ({
    status: null,
    timestamp: null,
    readyForOffline: true,
  }),

  actions: {
    setReadyForOffline(payload: boolean = false) {
      this.readyForOffline = payload
    },

    async send(): Promise<SendResult> {
      const results: SendResult = {
        status: null,
        timestamp: new Date().toUTCString(),
      }

      try {
        const [check, conf] = await Promise.all([
          fetch('api/v3/healthcheck').then((res) => res.json()),
          fetch('api/v3/conf.json').then((res) => res.json()),
        ])

        const installedVersion = usePartnerConfigStore().release.version

        if (!check.version || !installedVersion) {
          results.status = null
        } else if (check.version === installedVersion) {
          results.status = 'up_to_date'
        } else if (check.version === conf.release?.version) {
          results.status = 'downloaded'
        } else {
          results.status = 'out_of_date'
        }

        this.status = results.status
        this.timestamp = results.timestamp
      } catch (e) {
        console.error(e)
      }

      return results
    },
  },
})